import { useEffect, useState } from "react";
import api from "../../api/client";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Loader2 } from "lucide-react";

export default function PendingJobsPage() {
 const [jobs, setJobs] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 fetchPendingJobs();
 }, []);

 const fetchPendingJobs = async () => {
 try {
 const res = await api.get("/recruiter/jobs/pending"); // 🔑 call pending jobs endpoint
 setJobs(res.data.jobs);
 } catch (err) {
 console.error(err);
 } finally {
 setLoading(false);
 }
 };

 if (loading) {
 return (
 <div className="flex justify-center items-center h-screen">
 <Loader2 className="animate-spin w-8 h-8 text-indigo-600" />
 </div>
 );
 }

 return (
 <div className="min-h-screen py-6 px-3 sm:px-6 lg:px-8 ">
 <div className="max-w-6xl mx-auto">
 <Card className="shadow-md border border-border">
 <CardHeader>
 <CardTitle className="text-xl font-semibold">
 Jobs Pending Admin Approval
 </CardTitle>
 </CardHeader>
 <CardContent>
 {jobs.length === 0 ? (
 <p className="text-center text-muted-foreground py-10">
 No pending jobs to show.
 </p>
 ) : (
 <div className="overflow-x-auto">
 <table className="min-w-full divide-y divide-border text-sm">
 <thead className="">
 <tr>
 <th className="px-4 py-2 text-left">Title</th>
 <th className="px-4 py-2 text-left">Location</th>
 <th className="px-4 py-2 text-left">Type</th>
 <th className="px-4 py-2 text-left">Salary</th>
 <th className="px-4 py-2 text-left">Tags</th>
 <th className="px-4 py-2 text-left">Created At</th>
 </tr>
 </thead>
 <tbody className="divide-y divide-border">
 {jobs.map((job) => (
 <tr key={job.id} className="hover:">
 <td className="px-4 py-2">{job.title}</td>
 <td className="px-4 py-2">{job.location}</td>
 <td className="px-4 py-2">{job.type}</td>
 <td className="px-4 py-2">
 {job.salaryMin && job.salaryMax
 ? `${job.salaryMin.toLocaleString()} - ${job.salaryMax.toLocaleString()} ETB`
 : "—"}
 </td>
 <td className="px-4 py-2">
 {job.tags?.length > 0 ? job.tags.join(", ") : "—"}
 </td>
 <td className="px-4 py-2">{new Date(job.createdAt).toLocaleDateString()}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 )}
 </CardContent>
 </Card>
 </div>
 </div>
 );
}
